import { PATHS, URL_PARAMS } from '../constants';

export const redirectOnMissingToken = (): void => {
    // Get URL parts from current location
    const currentUrl = new URL(window.location.href);
    const { protocol, host, pathname } = currentUrl;

    const targetUrl = `${protocol}//${host}${PATHS.SIGN_IN}?${URL_PARAMS.TOKEN_MISSING}=true&${URL_PARAMS.REDIRECT_TO}=${pathname}`;

    if (window.location.href.toString() !== targetUrl) {
        // Navigate to the Sign In page, including URL params so that the user is redirected
        // to their original destination after they authenticate
        window.location.replace(targetUrl);
    }
};
